<section class="category-hero" [class.has-image]="!!bannerImage">
  <div class="category-hero__bg" *ngIf="bannerImage">
    <img class="category-hero__image" [src]="bannerImage" [alt]="titleZh || titleEn" onerror="this.style.display='none'">
    <div class="category-hero__scrim"></div>
  </div>

  <div class="category-hero__content">
    <p class="category-hero__breadcrumb" *ngIf="breadcrumbLabel" i18n="@@category.hero.breadcrumb">首頁 / {{ breadcrumbLabel }}</p>
    <h1 class="category-hero__title font-display" *ngIf="titleZh || titleEn">{{ titleZh || titleEn }}</h1>
    <p class="category-hero__tagline font-display" *ngIf="tagline">{{ tagline }}</p>
    <p class="category-hero__desc" *ngIf="description">{{ description }}</p>
  </div>
</section>
